import { tmsBE as service } from '../base/services';
import Endpoint from '../base/endpoint';

const fetchSellerId = new Endpoint(service, 'get', '/public/spot/{{spotId}}');

export default {
  fetchSellerId
};
